export const highRiskRegions = ['brazilsouth'];
